module.exports = __webpack_public_path__ + "img/duanmianxijizuo.prt.cf736ac2.jpg";